import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllMemberTags } from '@API/api_member_tags';


// action
export const fetchMemberTags = createAsyncThunk(
  'memberTags/fetchMemberTags',
  async (token, { rejectWithValue }) => {
    try {
      const response = await getAllMemberTags(token);
      if (response.data.status === 'success') {
        return response.data.data.tags.map(tag => ({
          value: tag.id.toString(),
          label: tag.tag_name
        }));
      }
    } catch (err) {
      console.log('Failed to fetch tags:', err);
      return rejectWithValue('無法載入會員標籤，請稍後再試');
    }
  }
);

// slice
const memberTagsSlice = createSlice({
  name: 'memberTags',
  initialState: {
    memberTags: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberTags.fulfilled, (state, action) => {
        state.loading = false;
        state.memberTags = action.payload;
      })
      .addCase(fetchMemberTags.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.error.message;
        state.error = action.payload; // derive from `rejectWithValue`
      });
  }
});

export default memberTagsSlice.reducer;